<script lang="ts">
	import CkEditorContent from "@components/common/CkEditorContent.svelte";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const { data, lightboxId }: ContentBlockComponentProps<ContentType.CKEditor> = $props();
</script>

<CkEditorContent html={data.html} {lightboxId} class="container-8" />
